<form
  [formGroup]="changeStatusForm"
  class="grid">
  <div
    class="field col-12"
    [ngClass]="{ 'md:col-6': type !== 'ticket', 'md:col-4': type === 'ticket' }">
    <label>Stato attuale</label>
    <div class="flex">
      <input
        pInputText
        type="text"
        class="w-full"
        [value]="status?.label || 'Nessuno stato'"
        [disabled]="true" />
    </div>
  </div>

  <div
    class="field col-12"
    [ngClass]="{ 'md:col-6': type !== 'ticket', 'md:col-4': type === 'ticket' }">
    <label>Stato successivo*</label>
    <p-dropdown
      [placeholder]="statuses.length === 0 ? 'Non ci sono altri stati.' : 'Scegli...'"
      formControlName="next_status"
      [options]="statuses"
      optionLabel="to_label"
      styleClass="w-full"
      [filter]="true"
      appendTo="body"
      [emptyMessage]="'Nessun risultato trovato'"
      [disabled]="statuses.length === 0"></p-dropdown>
  </div>

  <div
    class="field col-12 md:col-4"
    *ngIf="type === 'ticket'">
    <label>Tag ticket</label>
    <p-dropdown
      [placeholder]="tags.length === 0 ? 'Non ci sono altri tag.' : 'Scegli...'"
      formControlName="next_tag"
      [options]="tags"
      optionValue="id"
      optionLabel="description"
      styleClass="w-full"
      [filter]="true"
      appendTo="body"
      [emptyMessage]="'Nessun risultato trovato'"
      [disabled]="tags.length === 0"></p-dropdown>
  </div>

  <div
    class="field col-12"
    *ngIf="ticket && integrationNote">
    <label for="integration-note"
      >Nota integrazione<span *ngIf="integrationNote.required">*</span>
      <i
        class="text-color-nes-teal cursor-pointer pi pi-info-circle ml-1"
        pTooltip="Questa transizione prevede una nota per le integrazioni: viene salvata sul ticket e sincronizzata con i sistemi con cui la commessa si integra."
        tooltipPosition="bottom"></i
    ></label>
    <textarea
      id="integration-note"
      pInputTextarea
      class="w-full mt-1"
      rows="3"
      [maxlength]="maxIntegrationNoteLength"
      [placeholder]="integrationNote.required ? 'Nota obbligatoria' : 'Nota facoltativa'"
      formControlName="integration_note"></textarea>
  </div>

  <div
    class="col-12"
    *ngIf="ticket && changeStatusForm.value.next_status?.to === 3">
    <label>Chiusura effettiva</label>
    <p-calendar
      [firstDayOfWeek]="1"
      dateFormat="dd/mm/yy"
      styleClass="w-full"
      formControlName="closed_on"
      [showTime]="true"
      appendTo="body"
      [showIcon]="true">
    </p-calendar>
  </div>
</form>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="changeStatusForm.invalid">
    </p-button>
  </div>
</div>
<!-- [ngClass]="{'disabled': next_status.invalid || (next_status.value?.to === 3 && closed_on.invalid)}" -->
<!-- <pre>{{ status | json }}</pre> -->
